class BoostWidgetIntegrationAPI {
  constructor() {
    this.registerEvents();
  }

  registerEvents() {
    // Register with Boost widget
    boostWidgetIntegration.regisCustomization(() => this.afterRender());

    // Also run after window load
    window.addEventListener("load", () => this.afterRender());
  }

  afterRender() {
    try {
      const boostGrid = document.querySelector('.boost-sd__product-list');

      if (!boostGrid) {
        console.log("Boost grid not found, skipping...");
        return;
      }

      this.extractAllProductData(boostGrid);
    } catch (error) {
      console.warn(error);
    }
  }

  extractAllProductData(boostGrid) {
    const productItems = boostGrid.querySelectorAll('.boost-sd__product-item');

    productItems.forEach((item) => {
      const productData = this.getProductData(item);
      if (productData) {
        this.displayElements(item, productData);
      }
    });
  }

  displayElements(element, productData) {
    const metafieldLabel = element.querySelector('.boost-sd__product-label--custom-label-by-metafield1');

    if (metafieldLabel) {
      const labelText = metafieldLabel.textContent.trim().toLowerCase();
      if (labelText === 'free shipping') {
        metafieldLabel.style.display = 'none';
        metafieldLabel.classList.add('hide');
      }
    }
  }

  
  getProductData(element) {
    if (!element) {
      console.error('No element provided for data extraction.');
      return null;
    }

    let rawData = element.getAttribute('data-product');
    if (!rawData) {
      console.error('No data-product attribute found.');
      return null;
    }

    // Decode HTML entities
    let decodedData = rawData
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#39;/g, "'");

    try {
      const productData = JSON.parse(decodedData);

      // If variants is still a string, parse that too
      if (typeof productData.variants === 'string') {
        productData.variants = JSON.parse(productData.variants);
      }

      return productData;
    } catch (e) {
      console.error('Error parsing product data:', e);
      return null;
    }
  }
}

// Initialize the class
new BoostWidgetIntegrationAPI();
